module.exports = __webpack_public_path__ + "images/icons/size-guide/vehicle-10x25.svg";